// use-tenant-id.ts
import axios from 'axios'
import { atom, useAtom } from 'jotai'
import { useEffect } from 'react'
import pkg from '../../package.json'

function setDefaultTenantHeader(tenantId?: string) {
  if (tenantId?.length) {
    axios.defaults.headers['X-Tenant-Id'] = tenantId
  } else {
    // remove header while unknown/empty to avoid bad requests
    delete axios.defaults.headers['X-Tenant-Id']
  }
}

const TENANT_ID_KEY = `${pkg.name}.tenantId`
const TENANT_ID_USER_KEY = `${pkg.name}.user`

// Start as null => “loading”
const baseTenantIdAtom = atom<string >("")

export const useTenantId = () => {
  const [tenantId, setTenantId] = useAtom(baseTenantIdAtom)

  // One-time bootstrap
  useEffect(() => {
    if (tenantId?.length) return // already bootstrapped

    let fromLocal = localStorage.getItem(TENANT_ID_KEY) || ''
    if (!fromLocal) {
      const userStr = localStorage.getItem(TENANT_ID_USER_KEY)
      if (userStr?.length) {
        try {
          const parsed = JSON.parse(userStr)
          fromLocal = parsed?.tenant_id || ''
        } catch {
          // ignore parse errors
        }
      }
    }
    setTenantId(fromLocal) // '' means “known but empty”
  }, [tenantId, setTenantId])

  // Keep axios header in sync
  useEffect(() => {
    setDefaultTenantHeader(tenantId)
  }, [tenantId])

  return { tenantId, setTenantId }
}
